export const normalizeCountryName = (country?: string) =>
  country
    ?.trim()
    .toLowerCase()
    .replace(/[().]/g, '')
    .replace(/\s+/g, ' ') || '';

export const ukCountries = [
  'united kingdom',
  'uk',
  'great britain',
  'england',
  'scotland',
  'wales',
  'northern ireland',
  'jersey',
  'guernsey',
  'isle of man',
];

export const indiaCountries = ['india'];

export const usCountries = [
  'united states',
  'united states of america',
  'usa',
  'us',
  'america',
];

export const canadaCountries = ['canada'];

export const australiaCountries = ['australia', 'new zealand'];

export const europeCountries = [
  'albania',
  'andorra',
  'austria',
  'belgium',
  'bosnia and herzegovina',
  'bulgaria',
  'croatia',
  'cyprus',
  'czech republic',
  'czechia',
  'denmark',
  'estonia',
  'finland',
  'france',
  'germany',
  'greece',
  'hungary',
  'iceland',
  'ireland',
  'italy',
  'latvia',
  'liechtenstein',
  'lithuania',
  'luxembourg',
  'malta',
  'moldova',
  'monaco',
  'montenegro',
  'netherlands',
  'north macedonia',
  'norway',
  'poland',
  'portugal',
  'romania',
  'san marino',
  'serbia',
  'slovakia',
  'slovenia',
  'spain',
  'sweden',
  'switzerland',
  'ukraine',
  'vatican city',
];

export type AcademicSystem<T> = {
  countries: string[];
  label: string;
  options: T[];
};

export const matchAcademicSystemByCountry = <T>(
  country: string | undefined,
  systems: AcademicSystem<T>[],
  fallbackSystem: AcademicSystem<T>,
) => {
  const normalizedCountry = normalizeCountryName(country);
  const matchedSystem = systems.find((system) =>
    system.countries.includes(normalizedCountry),
  );

  return matchedSystem || fallbackSystem;
};
